export default __webpack_public_path__ + "static/media/src_repairapp_m_5.4df92581.jpg";